import { Dispatch, SetStateAction } from "react";

/**
 * Creates a curried setter for any object-based React state.
 *
 * Usage:
 *   const [state, setState] = useState({ test: false });
 *   const handleFieldChange = createFieldSetter(setState);
 *
 *   // Updates state.test to true
 *   handleFieldChange("test")(true);
 *
 * This preserves full type safety:
 * - `field` must be a key of the state object
 * - `value` must match the type of that field
 */
export const useFieldSetter = <T extends object>(setState: Dispatch<SetStateAction<T>>) => {
  return <K extends keyof T>(field: K) => {
    return (value: T[K]) => {
      setState((prev) => ({ ...prev, [field]: value }));
    };
  };
};
